<div class="container">
    <div class="row items">
        <div class="col-md-6 item" *ngFor="let item of items; let i = index">
            <p class="text">
                <i class="quote">
                </i>{{item.text}}</p>
            <div class="item-link">
                <img height="40" [src]="item.img">
                <a [href]="item.link" target="_blank" class="btn ">{{item.details}}
                    <i class="bi bi-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</div>
